import portugueseMessages from '../../../config/portuguese-messages';

export const requiredLmc = (fieldValue, { lastMileCompanyInfo }) => {
  return fieldValue && !lastMileCompanyInfo?.name
    ? portugueseMessages.ra.validation.required
    : '';
};

export default { requiredLmc };
